import { render, staticRenderFns } from "./ModalVpnServerParams.vue?vue&type=template&id=305a41d4"
import script from "./ModalVpnServerParams.vue?vue&type=script&lang=js"
export * from "./ModalVpnServerParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports